// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bottom-4{bottom:1.5rem}.calendar-picker{color:#024668}.calendar-picker .text-lg{font-size:1.125rem;margin-bottom:0}.appointment-not-available{text-align:center;position:relative;z-index:1;color:#024668}@media screen and (max-height: 568px){.page-initial{min-height:500px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
